import {
    PROFILES_FETCH,
    PROFILES_FETCH_ALL,
    PROFILES_IS_FETCING,
    PROFILE_FILTER,
    PROFILE_EDIT,
    SINGLE_PROFILE_FETCH
} from 'constants/profiles'

export default function profilesReducer(state = {
    list: [],
    singleProfileFetched: {},
    pageable: {
        sort: {
            'profileId': 'asc',
            'name': false,
            'markupRebate': false,
            'commissionRebate': false,
            'mrPerType': false,
            'crPerType': false,
        },
        size: 10,
        page: 0,
        totalPages: 0,
        totalElements: 0,
    }
}, action) {
    switch (action.type) {
				case SINGLE_PROFILE_FETCH:
					return {
						...state,
						singleProfileFetched: action.payload
					}
        case PROFILES_FETCH:
            return {
                ...state,
                list: action.payload,
            }
        case PROFILES_FETCH_ALL:
            return {
                ...state,
                list: action.payload,
            }
        case PROFILE_EDIT:
            return {
                ...state,
                // list: state.list.find(e=>state.profileId===e.profileId)?,
            }
        case PROFILES_IS_FETCING:
            return {
                ...state,
                isFetching: action.payload,
            }
        case PROFILE_FILTER:
            return {
                ...state,
                pageable: {
                    ...state.pageable,
                    ...action.payload,
                    sort: action.payload.sort ? {
                        ...Object.keys(state.pageable.sort).reduce((obj, i) => ({
                            ...obj,
                            [i]: false
                        }), {}),
                        ...action.payload.sort
                    } : state.pageable.sort,
                },
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/profiles.js